import axios from "axios";

// Résolution de l'URL backend
// Priorité 1 : window.APP_CONFIG.apiUrl (éditable sur le serveur, sans rebuild)
//   '' (vide) = URLs relatives /api/ → nginx proxy → backend local (production)
//   'https://...' = URL absolue → backend distant (si besoin)
// Priorité 2 : REACT_APP_BACKEND_URL (baked-in au build, fallback si config.js absent)
const configUrl = window.APP_CONFIG?.apiUrl;
const backendUrl = (configUrl !== undefined && configUrl !== null)
  ? configUrl
  : (process.env.REACT_APP_BACKEND_URL || '');

export const API = `${backendUrl}/api`;

if (!axios.__eudemonieSitePlanPreview) {
  axios.interceptors.request.use(config => {
    if (typeof window === "undefined" || !config?.url) return config;
    const token = new URLSearchParams(window.location.search).get("site_plan_preview");
    if (token && /\/api\/public\/(settings|pages\/)/.test(config.url)) {
      config.params = { ...(config.params || {}), site_plan_preview: token };
    }
    return config;
  });
  axios.__eudemonieSitePlanPreview = true;
}
